import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import VueGtagPlugin from 'vue-gtag';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/stytle/reset.css'
import FastClick from 'fastclick'
FastClick.attach(document.body);

Vue.use(ElementUI);
Vue.use(VueGtagPlugin, {
  config: {
    id: 'G-K8H3NGZ2LM',
  },
});
import router from '@/router/index'
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

